import { soilSelfGetService } from '@/util/Request';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import IfComponent from '../IF/IfComponent';
import './index.less';
interface IProps {
    children: (color: string) => JSX.Element
    title: string
    path?: string
    selected: boolean
    onClick?: () => void
    included?: boolean
    type?: 'url' | 'link'
}

const SoilMenuItem = (props: IProps) => {
    const {
        title,
        path,
        selected,
        children,
        onClick,
        included = true,
        type='link',
    } = props;

    const [url, setUrl] = useState('');
    const [mouseOver, setMouseOver] = useState(false);
    const [color, setColor] = useState('#696F88');
    const mouseOverItem = (mouseOver: boolean) => {
        setMouseOver(mouseOver);
    };

    const location = useLocation();
    useEffect(() => {
        // const token = localStorage.getItem('accessToken');
        // if (token) {
        if(type=='url' && location.pathname === '/feedback'){
            getAllService();
        }
        // }
    }, [location]);
    const getAllService = async () => {
        try {
            const res = await soilSelfGetService();
            setUrl(res);
        } catch (err) {
            console.log('home err', err);
        }
    };

    useEffect(() => {
        if (selected) {
            setColor('#59B948');
        } else {
            setColor('#696F88');
        }
    }, [selected]);

    return (
        <li className='weather-liclass' style={{ display: `${included ? 'block' : 'none'}` }} onClick={() => onClick && onClick()}>
            <IfComponent show={type==='link'}>
                <Link to={path}>
                    <div
                        className={`hover-bottom-div ${mouseOver && 'hover-style'}`}
                        onMouseOver={() => mouseOverItem(true)}
                        onMouseLeave={() => mouseOverItem(false)}
                    >
                        <div className='svg-super-div'>
                            <div className='svg-div' style={{ background: `${selected ? '#59B9481A' : 'transparent'}` }}>
                                {children(color)}
                            </div>
                        </div>
                        <span className={`weather-query-span ${(selected || mouseOver) && 'weather-hover-span' }`}>
                            {title}
                        </span>
                    </div>
                </Link>
            </IfComponent>
            <IfComponent show={type === 'url'}>
                <a href={url}>
                    <div
                        className={`hover-bottom-div ${mouseOver && 'hover-style'}`}
                        onMouseOver={() => mouseOverItem(true)}
                        onMouseLeave={() => mouseOverItem(false)}
                    >
                        <div className='svg-super-div'>
                            <div className='svg-div' style={{ background: `${selected ? '#59B9481A' : 'transparent'}` }}>
                                {children(color)}
                            </div>
                        </div>
                        <span
                            className={`weather-query-span ${(selected || mouseOver) && 'weather-hover-span' }`}
                        >
                            {title}
                        </span>
                    </div>
                </a>
            </IfComponent>
        </li>
    );
};

export default SoilMenuItem;
